export default __webpack_public_path__ + "static/media/chris.bbcbfc44.png";